import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { DocTokenService } from './doc-token.service';

@Injectable({
  providedIn: 'root',
})

export class DocAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: DocTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}